/*
 * Cart page - Clear all
 * ---------------------
 * Adds a "Clear all" control above the cart table so a shopper can empty the
 * cart in one action instead of pressing Remove on every line. Fabric orders
 * often run to a dozen lines, and rebuilding a cart from scratch is a common
 * way for a shopper to start over.
 *
 * WHY THIS IS A SCRIPT AND NOT MARKUP IN sections/main-cart.liquid
 *   main-cart.liquid is a 45KB section. Injecting from here keeps the change
 *   to two files and makes it removable without touching theme code, matching
 *   how the other TradeUNO customisations in this theme are built.
 *
 * BEHAVIOUR
 *   Two-step confirm. The first press swaps the label to "Tap again to clear"
 *   and arms for 5 seconds; a second press inside that window empties the cart.
 *   Emptying a cart cannot be undone by the shopper, and this control sits a
 *   few pixels from the quantity steppers, so a single misplaced tap should not
 *   destroy the basket. It reverts on its own if the second press never comes.
 *
 *   The clear itself is POST /cart/clear.js followed by a reload, so every
 *   dependent region - line items, subtotal, discounts, free shipping bar,
 *   header count - is repainted by the server rather than patched by hand.
 *
 * NOTE: /cart/clear.js does NOT remove discount codes already applied to the
 * cart; Shopify keeps those on the session. The cart will be empty but a
 * previously entered code can still reappear on the next add.
 *
 * TO REVERT: delete the <script> tag for this file from layout/theme.liquid.
 */
(function () {
  var ARM_MS = 5000;
  var STYLE_ID = 'tu-cart-clear-style';

  var armed = false;
  var armTimer = null;

  function root() {
    var base = '/';
    try {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        base = window.Shopify.routes.root;
      }
    } catch (e) {}
    if (base.charAt(base.length - 1) === '/') base = base.slice(0, -1);
    return base;
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '.tu-cart-clear-bar{display:flex;justify-content:flex-end;padding:0 0 8px}' +
      '.tu-cart-clear{background:none;border:0;padding:6px 2px;cursor:pointer;' +
      'font:inherit;font-size:1.4rem;line-height:1.2;color:currentColor;opacity:.7;' +
      'text-decoration:underline;text-underline-offset:3px}' +
      '.tu-cart-clear:hover{opacity:1}' +
      '.tu-cart-clear[data-armed]{opacity:1;font-weight:600;text-decoration:none}' +
      '.tu-cart-clear[disabled]{opacity:.5;cursor:progress}';
    document.head.appendChild(s);
  }

  function disarm(btn, label) {
    armed = false;
    if (armTimer) {
      window.clearTimeout(armTimer);
      armTimer = null;
    }
    btn.removeAttribute('data-armed');
    btn.textContent = label;
  }

  function clearCart(btn) {
    btn.disabled = true;
    btn.textContent = 'Clearing...';

    fetch(root() + '/cart/clear.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('clear failed');
        window.location.reload();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Could not clear - try again';
        window.setTimeout(function () {
          btn.textContent = 'Clear all';
        }, 3000);
      });
  }

  function build() {
    var table = document.querySelector('#hdt-page-cart .hdt-cart-items');
    if (!table || !table.parentNode) return false;
    if (document.querySelector('.tu-cart-clear')) return true;

    // No rows means an empty cart - nothing to clear, so show nothing.
    if (!table.querySelector('tbody tr')) return true;

    injectStyles();

    var label = 'Clear all';
    var bar = document.createElement('div');
    bar.className = 'tu-cart-clear-bar';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tu-cart-clear';
    btn.textContent = label;
    btn.setAttribute('aria-label', 'Remove all items from your cart');

    btn.addEventListener('click', function () {
      if (armed) {
        clearCart(btn);
        return;
      }
      armed = true;
      btn.setAttribute('data-armed', '');
      btn.textContent = 'Tap again to clear';
      armTimer = window.setTimeout(function () {
        disarm(btn, label);
      }, ARM_MS);
    });

    // Pressing anything else in the cart cancels the armed state, so an
    // abandoned first tap cannot be completed by a much later second one.
    document.addEventListener(
      'click',
      function (e) {
        if (armed && e.target !== btn) disarm(btn, label);
      },
      true
    );

    bar.appendChild(btn);
    table.parentNode.insertBefore(bar, table);
    return true;
  }

  function init() {
    if (build()) return;

    // The cart section can re-render after a quantity change. Bounded retry -
    // no permanent observer, matching tradeuno-cart-page-mode.js.
    var tries = 0;
    var timer = window.setInterval(function () {
      tries++;
      if (build() || tries > 20) window.clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-attach after the theme replaces the cart section markup.
  document.addEventListener('cart:refresh', function () {
    window.setTimeout(build, 100);
  });
})();
